import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { PageHeader, Section, Empty, RowLink } from "../components/common";
import { fmtDate } from "../lib/helpers";

export default function Warranties() {
  const { t, lang } = useLang();
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/warranties").then((r) => setList(r.data)); }, []);
  const active = list?.filter((p) => p.warranty_days_left >= 0) || [];
  const expired = list?.filter((p) => p.warranty_days_left < 0) || [];
  const Row = (p) => (
    <RowLink key={p.id} to={`/projects/${p.id}`} testid={`warranty-row-${p.id}`}>
      <div className="flex-1 min-w-0"><div className="font-semibold truncate">{p.name}</div><div className="text-xs text-slate-500 truncate">{p.customer_name} · {t("completed", "terminado")} {fmtDate(p.completion_date, lang)} · {p.warranty_years} {t("yr", "año(s)")}</div></div>
      <div className="text-right"><div className={`mono text-sm font-semibold ${p.warranty_days_left <= 60 && p.warranty_days_left >= 0 ? "text-amber-600" : ""}`}>{p.warranty_days_left >= 0 ? `${p.warranty_days_left} ${t("days", "días")}` : t("Expired", "Vencida")}</div><div className="text-xs text-slate-500">{fmtDate(p.warranty_expiration, lang)}</div></div>
    </RowLink>
  );
  return (
    <>
      <PageHeader title={t("Warranties", "Garantías")} subtitle={t("Calculated from each project's completion date.", "Calculadas desde la fecha de terminación de cada proyecto.")} />
      <div className="grid gap-4">
        <Section title={t("Active (soonest first)", "Activas (más próximas primero)")} count={active.length} testid="warranties-active">{active.length ? active.map(Row) : <Empty text={t("No active warranties", "Sin garantías activas")} />}</Section>
        <Section title={t("Expired", "Vencidas")} count={expired.length} testid="warranties-expired">{expired.length ? expired.map(Row) : <Empty text="—" />}</Section>
      </div>
    </>
  );
}
